export default __webpack_public_path__ + "static/media/20200810_104859.9831e6f5.JPG";